const selectedLocaleKey = 'nnet-selected-locale';

const detectBrowserLocale = (): string => {
  const browserLocales = navigator.languages ?? [navigator.language];
  if (browserLocales.length > 0) {
    return browserLocales[0].split('-')[0].toLowerCase();
  }

  return 'tr';
};

export const getSelectedLocale = () => {
  if (typeof window === 'undefined') {
    return 'tr';
  }

  return localStorage.getItem(selectedLocaleKey) || detectBrowserLocale();
};

export const setSelectedLocale = (locale: string) =>
  localStorage.setItem(selectedLocaleKey, locale);
